import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'trustedurl'
})
export class TrustedurlPipe implements PipeTransform {
  constructor(private _dom: DomSanitizer) { }
  transform(value: any, args?: any): any {
    return this._dom.bypassSecurityTrustResourceUrl(value);
  }

}
